import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: '12px',
        fontSize: '0.833rem',
        padding: '0.1em 1.6rem',
        lineHeight: '2.0',
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.text.primary,
        '&:hover': {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.common.white,
            borderColor: theme.palette.primary.main,
        },
    },
    text: {
        color: theme.palette.primary.main,
        backgroundColor: 'transparent',
        '&:hover': {
            color: '#2083fe',
            backgroundColor: 'transparent',
        },
    },
    textPrimary: {
        color: theme.palette.primary.main,
    },
    textSecondary: {
        color: theme.palette.secondary.main,
    },
    contained: {
        border: '2px solid white',
        boxShadow: '1px 1px rgba(0,0,0,0.15)',
        textTransform: 'none',
        transition: '0.2s ease all',
    },
    containedPrimary: {
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
        },
    },
    containedSecondary: {
        backgroundColor: theme.palette.secondary.main,
        '&:hover': {
            color: theme.palette.secondary.main,
            borderColor: theme.palette.secondary.main,
        },
    },
    outlined: {
        transition: 'none',
        borderWidth: '1px',
        '&:hover': {
            borderWidth: '2px',
            margin: '-1px',
        },
    },
    outlinedPrimary: {
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        backgroundColor: 'rgba(0,0,0,0)',
        '&:hover': {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            backgroundColor: 'rgba(0,0,0,0)',
        },
    },
    outlinedSecondary: {
        backgroundColor: 'rgba(0,0,0,0)',
        color: theme.palette.secondary.main,
        borderColor: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0)',
            color: theme.palette.secondary.main,
            borderColor: theme.palette.secondary.main,
        },
    },
}));

export const useOtherStyles = makeStyles((theme) => ({
    wrapper: {
        //margin: theme.spacing(1),
        position: 'relative',
    },
    buttonProgress: {
        color: '#069',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -10,
        marginLeft: -10,
        zIndex: 10,
    },
}));

export default useStyles;
